import { render } from "./BasicInput.vue?vue&type=template&id=7e6ea0e5&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"

import "./BasicInput.vue?vue&type=style&index=0&id=7e6ea0e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e6ea0e5"

export default script